import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize () {
    const currentDevice = window.innerWidth < 992 ? 'mobile' : 'desktop';
    let buttonClass = (currentDevice == 'desktop') ? '.mobile-lesson-buttons' : '.desktop-lesson-contents'

    document.querySelectorAll(buttonClass).forEach(el => el.remove());

    window.addEventListener('resize', function () {
      const width = window.innerWidth;
      let newDevice = 'desktop'

      if (width < 992) {
        newDevice = 'mobile'
      }

      if (currentDevice !== newDevice) {
        location.reload();
      }
    });
  }
}
